import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/$project/inferenceendpoints/$name/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$org/$project/inferenceendpoints/$name/$tab", params: { ...params, tab: "overview" } });
  },
});
